import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Diamonds from './pages/Diamonds';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import DiamondDetails from './pages/DiamondDetails';
import ProtectedRoute from './components/ProtectedRoute';
import ScrollToTop from './components/ScrollToTop';
import AdminLayout from './components/AdminLayout';
import CalculateCost from './pages/CalculateCost';

import AOS from 'aos';
import 'aos/dist/aos.css';

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000, // global duration
      once: true, // whether animation should happen only once - while scrolling down
    });
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <div className="text-light min-vh-100">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/diamonds" element={<Diamonds />} />
          <Route path="/diamond/:id" element={<DiamondDetails />} />
          <Route path="/login" element={<Login />} />
          <Route 
            path="/dashboard" 
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            } 
          >
            <Route index element={<Dashboard />} />
            <Route path="calculate-cost" element={<CalculateCost />} />
          </Route>
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
